import React from "react";
import { CollectionIcon } from "../icon_templates/icons";
import { Tooltip } from "@mui/material";
import "../assets/styles/searchmenu.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import SyncIcon from "@mui/icons-material/Sync";
import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import { Button, Typography } from "@mui/material";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { triggerAlert } from "./AlertMessage";
import { Autocomplete, TextField } from "@mui/material";
import { Slider } from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useEffect } from "react";
import { getTaskList } from "../assets/constants/global_apis";

export default function SearchMenu({
  filterFunction,
  ElementList,
  handleOnClickItem,
  handleDelete,
  selectedItem,
  isActiveRequired,
  title,
  buttonAction,
  handleRefreshAgents,
  isDeleteNotRequired,
  customMenuIcon,
  handleModalOpen,
  handleCloseModal,
  open,
  handleSubmitConfirmation,
  errors,
  setFormFields,
  formFields,
  onSubmit
}) {
  const [formData, setFormData] = useState({});
  function convertUTCToLocalTime(utcDateString) {
    const utcDate = new Date(utcDateString);
    return new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
  }
  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? event.target.files[0] : value
    }));
  };

  // Handle form submission
  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <div className='col-md-3 search-menu-container'>
      <div style={{ backgroundColor: "#f8f9fa" }} className='mt-0'>
        <div className='card h-100 rounded-0  border-top-0 border-bottom-0 border-start-0 bg-transparent'>
          <div className='card-header d-flex align-items-center justify-content-between'>
            <input
              type='text'
              className='form-control me-2 w-100'
              placeholder={`Search ${title}s`}
              onChange={(e) => filterFunction(e)}
            />
            {buttonAction == "Refresh" ? (
              <SyncIcon
                className='refresh-icon'
                onClick={handleRefreshAgents}
              />
            ) : (
              ""
            )}
          </div>
          {buttonAction == "Create New" ? (
            <button
              className='btn btn-sm btn-dark create-new-button'
              onClick={handleModalOpen}
            >
              {buttonAction} {title}
            </button>
          ) : (
           <button
                className='btn btn-sm btn-dark create-new-button'
                data-bs-toggle='modal'
                data-bs-target='#createCollectionModal'
              >
                {buttonAction} {title}
              </button>
          )}
          <div className='card-body p-0'>
            <div style={{ height: "calc(100vh - 115px)", overflow: "auto" }}>
              <div className='collectionPane border-0'>
                {ElementList?.length > 0
                  ? ElementList.map((element, index) => {
                    const lastTimestamp = element.last_timestamp
                      ? convertUTCToLocalTime(element.last_timestamp)
                      : null;

                    const currentTime = new Date();
                    const timeDiffMinutes = lastTimestamp
                      ? (currentTime - lastTimestamp) / (1000 * 60)
                      : 0;
                    const iconColorClass =
                      timeDiffMinutes > 5 ? "text-danger" : "text-success";
                    return (
                      <Tooltip
                        title={element.label}
                        placement='top'
                        arrow
                        key={index}
                        onClick={() => {
                          handleOnClickItem(element, index);
                        }}
                      >
                        <div
                          className={`${selectedItem?.id === element.id
                            ? "d-flex justify-content-between align-items-center collection-lists active"
                            : "d-flex justify-content-between align-items-center collection-lists"
                            }`}
                        >
                          <div className='text-truncate'>
                            {customMenuIcon ? (
                              customMenuIcon
                            ) : (
                              <CollectionIcon />
                            )}
                            <span>{element.label}</span>
                          </div>
                          {isActiveRequired && isActiveRequired === true && (
                            <span>
                              <FontAwesomeIcon
                                className={`server-online ${iconColorClass}`}
                                icon={faCircle}
                              />
                            </span>
                          )}
                          {isDeleteNotRequired ? (
                            ""
                          ) : (
                            <button
                              className='btn btn-sm btn-danger delete-button'
                              onClick={(e) =>
                                handleDelete(e, element.label, element.id)
                              }
                              title={`Delete ${title}`}
                            >
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                fill='none'
                                viewBox='0 0 24 24'
                                strokeWidth={1.5}
                                stroke='#fff'
                                className='size-6'
                              >
                                <path
                                  strokeLinecap='round'
                                  strokeLinejoin='round'
                                  d='m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0'
                                />
                              </svg>
                            </button>
                          )}
                        </div>
                      </Tooltip>
                    );
                  })
                  : "No data available"}
              </div>
            </div>
          </div>
        </div>
      </div>

     {formFields && Object.keys(formFields).length > 0 &&  <Modal className="create-dataset-modal-cotainer" open={open} onClose={handleCloseModal}>
        <>
          {errors?.type != '' &&
            <div className="error-message-container">  {/* Fixed typo */}
              <span className={`alert-message ${errors?.type === 'error' ? 'error-message' : errors?.type === 'success' ? 'success-message' : errors?.type === 'info' ? 'info-message' : ''}`}>
                {errors?.message}
              </span>
            </div>
          }
          <Box className="modal-box-container">
            {/* Header */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography variant="h5" sx={{ textAlign: "center", flexGrow: 1 }} className="modal-title">
                Create {formFields?.title}
              </Typography>
              <FontAwesomeIcon icon={faTimes} onClick={handleCloseModal} className="modal-close-button" />
            </Box>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              {formFields.fields.map((field, index) => (
                <div key={index} className="input-fields-container">
                  <div className="text-sm font-semibold text-gray-700 input-labels">{field?.label}</div>
                  {field?.type === "textarea" ? (
                    <textarea
                      name={field?.name}
                      rows={3}
                      placeholder={"Enter " + field?.label}
                      className="form-input-fields p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 "
                      onChange={handleChange}
                    />
                  ) : field?.type === "file" ? (
                    <input
                      type="file"
                      name={field?.name}
                      placeholder={"Enter " + field?.label}
                      className="upload-file-input p-2 border border-gray-300 rounded-md file:bg-gray-200 file:border-0 file:px-3 file:py-2"
                      onChange={handleChange}
                    />
                  ) : field?.type === "json" ? (
                    <input
                      type="text"
                      name={field?.name}
                      placeholder="Enter JSON"
                      className="form-input-fields p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                      onChange={handleChange}
                    />
                  ) : (
                    <input
                      type={field?.type}
                      name={field?.name}
                      placeholder={"Enter " + field?.label}
                      className="form-input-fields p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                      onChange={handleChange}
                    />
                  )}
                </div>
              ))}
            </div>

            <div className="flex justify-center mt-4 text-center [text-align-last:center]">
              <button
                className="submit-button px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition duration-200"
                onClick={handleSubmit}
              >
                Create {formFields?.title}
              </button>
            </div>
          </Box>
        </>
      </Modal>}

    </div>
  );
}
